import Button from '@components/Button';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { ShopOrderStatus, ShopStatus } from '@models/shop/common';
import { useFlow } from '@stackflow/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    shopId: string;
    status: ShopOrderStatus;
    shopStatus: ShopStatus;
}

function OrderButton({ shopId, status, shopStatus }:Props) {
    const { push, pop } = useFlow();
    const { t } = useTranslation('shopDetail');
    const disabled = status !== 'OPEN';
    const project = useProject();
    const message = useMemo(() => {
        if (project?.features.orderEnabled) {
            if (shopStatus === 'NOT_USE_APP_ORDER') {
                return t('button.viewMenu');
            }
            return disabled ? t('button.preparing') : t('button.goToOrder');
        }
        return t('button.viewMenu');
    }, [disabled, project, shopStatus, t]);
    if (shopStatus === 'NOT_USE_APP_ORDER') {
        return null;
    }
    return (
        <Container>
            <Button fullWidth
                disabled={disabled}
                onClick={() => {
                    pop();
                    push('ItemsActivity', { shopId, type: 'ALL' });
                }}>
                {message}
            </Button>
        </Container>
    );
}

const Container = styled.div`
    padding: 16px 18px 20px;
    width: 100%;
    position: absolute;
    right: 0;
    bottom: 16px;
`;

export default OrderButton;
